/** Same group shape as `TicketChatSideBar` / `GroupTicket` / `ChangeGroupPopup`. */
export function mapApiGroupsToSidebarGroups(groups) {
  if (!Array.isArray(groups)) return [];
  return groups.map((g) => ({
    _id: g._id,
    title: g.name || g.title,
    group_image: g.image || g.group_image,
    agents: g.agents,
  }));
}

export function buildDefaultGroupsFromTicket(ticket) {
  if (Array.isArray(ticket?.groups) && ticket.groups.length) {
    return ticket.groups.map((g) => ({
      _id: g._id,
      title: g.title || g.name,
      group_image: g.group_image || g.image,
      agents: g.agents,
    }));
  }
  const g = ticket?.group;
  if (!g?.name) return [];
  const tid = ticket?.id || ticket?._id || "x";
  return [
    {
      _id: g._id || `tv2-group-${tid}`,
      title: g.name,
      group_image: g.image || g.group_image || null,
      agents: typeof g.members === "number" ? g.members : g.agents ?? 0,
    },
  ];
}

/** Map API ticket.tags (string or {_id,name}) to tag id strings for add/remove endpoints. */
export function normalizeTagIdsFromRaw(tags, chatTagsList) {
  if (!Array.isArray(tags)) return [];
  const list = Array.isArray(chatTagsList) ? chatTagsList : [];
  const nameToId = new Map(
    list.map((t) => {
      const n = String(t.name || "").toLowerCase();
      return [n, String(t._id)];
    })
  );
  const out = [];
  for (const x of tags) {
    if (typeof x === "string") {
      const byName = nameToId.get(x.toLowerCase());
      out.push(byName || x);
    } else if (x && typeof x === "object" && x._id) {
      out.push(String(x._id));
    }
  }
  return Array.from(new Set(out.filter(Boolean)));
}

export function tagLabelForId(tagId, chatTagsList) {
  const t = (chatTagsList || []).find((c) => String(c._id) === String(tagId));
  return t?.name || tagId;
}

export function sameTagIdOrder(a, b) {
  if (a.length !== b.length) return false;
  return a.every((id, i) => String(id) === String(b[i]));
}

export const STATUS_LABEL_BY_API = {
  open: "Open",
  pending: "Pending",
  solved: "Solved",
  spam: "Spam",
};

export function mapApiPriorityToSelect(p) {
  if (!p || typeof p !== "string") return "";
  const s = p.trim().toLowerCase();
  const map = { urgent: "Urgent", high: "High", medium: "Medium", low: "Low" };
  return map[s] || s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}
